import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sub-code',
  templateUrl: './sub-code.component.html',
  styleUrls: ['./sub-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubCodeComponent {
}
